module.exports = __webpack_public_path__ + "img/5.5f5b5bbe.png";